import { GsFormSchema } from '../../../components/gs-form/interfaces/gs-form-schema';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { DISPLAY_MODE_SCHEMA } from './../basics/display-mode.schema';
import { SWIPER_SCHEMA_FIELDS } from './../basics/swiper.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the categories component form.
 * Defines the fields to display for the form.
 */
export const ARTICLE_RATINGS_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ACTIVE_SCHEMA_FIELDS,
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    ...DISPLAY_MODE_SCHEMA,
    {
      formControlName: 'itemPadding',
      label: 'schema.items.itemPadding',
      type: 'padding',
      useTailwindClasses: true,
      groupingName: 'schema.items.name',
      default: {
        top: 4,
        right: 4,
        bottom: 4,
        left: 4
      }
    },
    // Slider
    ...SWIPER_SCHEMA_FIELDS
  ]
};
